(function () {

  'use strict';

  function pxOidc(IdpProviderService, IdpContextMenuMixin) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=',
        me: '='
      },
      templateUrl: 'app/components/authenticationSettings/oidc/oidc.template.html',
      link: function (scope) {
        scope.descriptor = IdpProviderService.descriptorByType('oidc');
        scope.directories = IdpProviderService.directoriesFor(scope.tenant, 'oidc');
        scope.redirectURI = IdpProviderService.redirectURIFor(scope.descriptor);
        scope.copyRedirectURI = function () {
          return IdpProviderService.copyRedirectURI(scope.descriptor);
        };
        IdpContextMenuMixin.attach(scope);
        IdpProviderService.attachListeners(scope, 'oidc');
      }
    };
  }

  pxOidc.$inject = ['IdpProviderService', 'IdpContextMenuMixin'];

  angular
    .module('printix-admin')
    .directive('pxOidc', pxOidc);

})();
